<template>
  <div v-if="emplacements">
    <div class="mgl-10px" v-if="emplacements.length > 0 && displayHeader">
      <header-emplacement-dispositif-materiel-face-picker :emplacements="emplacements">
      </header-emplacement-dispositif-materiel-face-picker>
    </div>
    <div v-if="emplacements.length > 0">
      <ligne-emplacement
              :emplacement="emplacement"
              class="mgt-10px"
              :dateDebut="dateDebut"
              :afficherCheckbox="afficherCheckboxEmplacement"
              :afficherCheckboxMateriel="afficherCheckboxMateriel"
              :afficherCheckboxFace="afficherCheckboxFace"
              :afficher-affectation="afficherAffectation"
              :afficherCheckboxDispositif="afficherCheckboxDispositif"
              :dateFin="dateFin"
              @passToFalse="$emit('passToFalse', $event)"
              :selectOnlyOneObject="selectOnlyOneObject"
              :index="index"
              v-for="(emplacement, index) in emplacements" :key="index">
      </ligne-emplacement>
    </div>
    <div v-else class="card has-text-centered mgt-20px">
      <p class="card-header-title has-text-default column is-12 has-text-centered">
        {{ $t('emplacementDispositifMaterielFacePicker.error.noResult') }}
      </p>
    </div>
    <footer-emplacement-dispositif-materiel-face-picker
        :value="page"
        :total="total"
        @input="paginationHandler">
    </footer-emplacement-dispositif-materiel-face-picker>
  </div>
</template>

<script>
import headerEmplacementDispositifMaterielFacePicker
  from '@/components/gabed/general/headerEmplacementDispositifMaterielFacePicker';
import footerEmplacementDispositifMaterielFacePicker
  from '@/components/gabed/general/footerEmplacementDispositifMaterielFacePicker';
import ligneEmplacement from '@/components/gabed/general/ligneEmplacement';

export default {
  name: 'emplacementDispositifMaterielFacePicker',
  props: {
    emplacements: {
      required: false,
      type: Array,
    },
    dateDebut: {
      required: false,
      type: Date,
      default() {
        return new Date();
      },
    },
    dateFin: {
      required: false,
      type: Date,
      default() {
        return new Date();
      },
    },
    total: {
      required: false,
      type: Number,
      default: 0,
    },
    selectOnlyOneObject: {
      required: false,
      type: Boolean,
      default: false,
    },
    afficherAffectation: {
      required: false,
      type: Boolean,
      default: true,
    },
    displayHeader: {
      required: false,
      type: Boolean,
      default: true,
    },
    afficherCheckboxMateriel: {
      required: false,
      type: Boolean,
      default: true,
    },
    afficherCheckboxFace: {
      required: false,
      type: Boolean,
      default: true,
    },
    afficherCheckboxDispositif: {
      type: Boolean,
      default: true,
    },
    afficherCheckboxEmplacement: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ligneEmplacement,
    headerEmplacementDispositifMaterielFacePicker,
    footerEmplacementDispositifMaterielFacePicker,
  },
  data() {
    return {
      page: {
        current: 1,
        limit: 20,
      },
    };
  },
  methods: {
    paginationHandler(value) {
      this.page = value;
      this.$emit('change', value);
    },
    openEmplacement() {
      if (this.emplacements.length > 0) {
        this.emplacements.forEach((emplacement) => {
          if (emplacement.dispositifs.length > 0) {
            emplacement.open = true;
            emplacement.dispositifs.forEach((dispositif) => {
              if (dispositif.materiels.length > 0) {
                dispositif.open = true;
                dispositif.materiels.forEach((mat) => {
                  if (mat.faces.length > 0) mat.open = true;
                });
              }
            });
          }
        });
      }
    },
  },
  mounted() {
    this.openEmplacement();
  },
};
</script>

<style scoped>

</style>
